import { ApiRequestError } from "../../../api/util";
import { useRevokeDelegationInvitation } from "../../../hooks/delegation/useRevokeDelegationInvitation";
import { Button } from "../../Button";
import Spinner from "../../graphics/Spinner";
import Modal, { ModalRoot } from "../../Modal/Modal";

interface RevokeDelegationInvitationModalProps {
  invitationId: string | null;
  onInvitationIdChange: (invitationId: string | null) => void;
  onError: (message: string) => void;
}

const RevokeDelegationInvitationModal = ({
  invitationId,
  onInvitationIdChange,
  onError,
}: RevokeDelegationInvitationModalProps) => {
  const revokeMutation = useRevokeDelegationInvitation();
  const isOpen = invitationId !== null;
  const isPending = revokeMutation.isPending;

  const handleOpenChange = (open: boolean) => {
    if (!open && !isPending) onInvitationIdChange(null);
  };

  const handleRevoke = async () => {
    if (!invitationId) return;

    try {
      await revokeMutation.mutateAsync(invitationId);
      onInvitationIdChange(null);
    } catch (err) {
      onError(
        err instanceof ApiRequestError
          ? err.message
          : "Kunne ikke tilbagekalde invitationen.",
      );
    }
  };

  return (
    <ModalRoot
      controller={{
        open: isOpen,
        setOpen: handleOpenChange,
      }}
    >
      <Modal
        small
        title="Tilbagekald invitation"
        description="Bekræft tilbagekaldelse af invitation"
        footer={
          <div className="d-flex justify-content-end gap-2 p-4">
            <button
              type="button"
              className="btn btn-outline"
              onClick={() => onInvitationIdChange(null)}
              disabled={isPending}
            >
              Annuller
            </button>
            <Button
              id="delegation-revoke-invitation-confirm"
              color="primary"
              onClick={handleRevoke}
              disabled={isPending}
            >
              {isPending ? (
                <span className="d-inline-flex align-items-center gap-2">
                  <Spinner inline size={16} label="" />
                  Tilbagekalder...
                </span>
              ) : (
                "Tilbagekald"
              )}
            </Button>
          </div>
        }
      >
        <p className="mb-0">
          Er du sikker på, at du vil tilbagekalde denne invitation? Linket vil
          ikke længere virke.
        </p>
      </Modal>
    </ModalRoot>
  );
};

export default RevokeDelegationInvitationModal;
